import { telemetryToClickAttributes } from '@modules/prism-client/lib/telemetry';
import { Button as WebCompositionsButton } from '@tuic/web-compositions/core/Button';

import { Link } from './Link';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { ButtonProps as WebCompositionsButtonProps } from '@tuic/web-compositions/core/Button';
import type { FC } from 'react';

type Props = WebCompositionsButtonProps & {
  data: PrismAPI.ButtonElement;
};

export const Button: FC<Props> = props => {
  return <WebCompositionsButton {...apiButtonToButtonProps(props)} />;
};

// eslint-disable-next-line react-refresh/only-export-components -- props mapper co-located with its component
export const apiButtonToButtonProps = ({
  data,
  ...props
}: Props): WebCompositionsButtonProps => {
  const children = data.link ? (
    <Link data={data.link}>{props.children ?? data.label}</Link>
  ) : (
    (props.children ?? data.label)
  );

  return {
    ...telemetryToClickAttributes(data.telemetry),
    ...props,
    variant: data.variant ?? props.variant,
    on: data.on ?? props.on,
    iconLeft: data.iconLeft ?? props.iconLeft,
    iconRight: data.iconRight ?? props.iconRight,
    asChild: props.asChild ?? !!data.link,
    type: data.htmlType ?? props.type,
    children,
  };
};
